import React from "react";
import moment from "moment";
import {Dropdown, Menu} from "antd";
import {DownOutlined} from "@ant-design/icons";
import {ChangeableInvoiceStatuses} from "../AdminInvoices/consts";
import {TableDoubleValueCell} from "../../components";
import {momentHebrewFormat} from "../../utils/DateFormat";
import {InvoicesStatusToNameAndColor} from "../../provider/ProviderManageInvoices/consts";

const getColumns = ({openDeliveryProviderOrders, openInvoice, updateStatus}) => [
    {
        title: "#",
        key: "#",
        width: 70,
        render(_, __, idx) {
            return `${idx + 1}`;
        }
    },
    {
        title: "מזהה חשבונית",
        dataIndex: "invoiceId"
    },
    {
        title: "שם ספק השילוח",
        key: "deliveryProvider",
        sorter: (r1, r2) => {
            return r1.deliveryProvider?.name?.localeCompare(r2.deliveryProvider?.name, undefined, {
                sensitivity: "accent"
            });
        },
        render(_, {deliveryProvider}) {
            return (
                <TableDoubleValueCell>
                    {deliveryProvider?.name ?? "ספק שילוח לא מאושר"}
                    {deliveryProvider?.email}
                </TableDoubleValueCell>
            );
        }
    },
    {
        title: "חשבונית עבור",
        dataIndex: "month",
        render(month, {deliveryProviderId, deliveryProvider}) {
            return (
                <TableDoubleValueCell className="admin-invoices-table-clickable-sub-text">
                    {momentHebrewFormat(moment(month), "MMMM YY")}
                    <span
                        onClick={() =>
                            openDeliveryProviderOrders({
                                deliveryProviderId,
                                deliveryProviderName: deliveryProvider?.name,
                                deliveryProviderEmail: deliveryProvider?.email,
                                month: moment(month)
                            })
                        }>
                        לפירוט החודשי
                    </span>
                </TableDoubleValueCell>
            );
        }
    },
    {
        title: "תאריך טעינה",
        dataIndex: "createdAt",
        sorter: ({createdAt: r1}, {createdAt: r2}) => r1 - r2,
        render(createdAt) {
            return moment(createdAt).format("HH:mm | DD.MM.YY");
        }
    },
    {
        title: "מס׳ משלוחים משויכים",
        key: "deliveries",
        sorter: ({deliveries: r1}, {deliveries: r2}) => r1 - r2,
        render(_, {deliveries, totalDeliveries}) {
            return `${deliveries.length}/${totalDeliveries}`;
        }
    },
    {
        title: "סכום החשבונית המוצהר (כולל מע״מ)",
        dataIndex: "price",
        sorter: ({price: r1}, {price: r2}) => r1 - r2,
        render(price, invoice) {
            return (
                <TableDoubleValueCell className="admin-invoices-table-clickable-sub-text">
                    {`${price.toLocaleString()} ₪`}
                    <span onClick={() => openInvoice(invoice)}>לפירוט החשבונית</span>
                </TableDoubleValueCell>
            );
        }
    },
    {
        title: "צפייה במסמך",
        key: "file",
        render(_, {file}) {
            return file ? (
                <div onClick={() => window.open(file.fileUrl, "_blank")} className="admin-invoices-table-file-cell">
                    {file.fileName}
                </div>
            ) : null;
        }
    },
    {
        title: "תנאי שוטף",
        key: "deliveryProviderPaymentTerms",
        render(_, {deliveryProvider}) {
            const paymentTerms = deliveryProvider?.paymentTerms;
            return paymentTerms ? `${paymentTerms} ימים` : "-";
        }
    },
    {
        title: "סטטוס",
        dataIndex: "status",
        sorter: ({status: r1}, {status: r2}) => (r1 || "").localeCompare(r2 || ""),
        render(status, {invoiceId}) {
            const statusNameAndColor = InvoicesStatusToNameAndColor[status];
            return statusNameAndColor ? (
                <Dropdown
                    trigger={["click"]}
                    overlay={
                        <Menu>
                            {ChangeableInvoiceStatuses.map(statusId => {
                                const optionNameAndColor = InvoicesStatusToNameAndColor[statusId];
                                return (
                                    <Menu.Item
                                        key={statusId}
                                        onClick={() => updateStatus(invoiceId, statusId)}
                                        style={{color: optionNameAndColor.color}}>
                                        {optionNameAndColor.name}
                                    </Menu.Item>
                                );
                            })}
                        </Menu>
                    }>
                    <span style={{color: statusNameAndColor.color}}>
                        {statusNameAndColor.name} <DownOutlined />
                    </span>
                </Dropdown>
            ) : null;
        }
    }
];

export default getColumns;
